"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../../container"));
var playlist_1 = require("../../selectors/playlist");
var player_1 = require("../../stores/player");
var mediafiles_1 = require("../../stores/mediafiles");
var regeneratePlaylist_1 = __importDefault(require("../generation/regeneratePlaylist"));
var exportHistoryItems_1 = __importDefault(require("./exportHistoryItems"));
var playbackHistory_1 = require("../../stores/playbackHistory");
var playlist_2 = require("../../stores/playlist");
var addRotationToHistory_1 = __importDefault(require("./addRotationToHistory"));
function addPlaybackHistoryItem(_, filename, nextTrackStart, onAir) {
    var action = function (dispatch, getState) {
        var _a, _b, _c, _d;
        var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/addPlaybackHistoryItem");
        var settings = _kernel_container_1.default.get("SETTINGS");
        var regenerateOnCorrection = settings.getSetting("REGENERATE_ON_CORRECTION", true);
        var minPlaylistLength = settings.getSetting("REGENERATE_MIN_PLAYLIST_LENGTH", 20);
        var maxCorrection = settings.getSetting("REGENERATE_MAX_CORRECTION", 10000);
        var historyDefaultMaxItems = settings.getSetting("HISTORY_DEFAULT_MAX_ITEMS", 12000);
        var state = getState();
        var playlistLength = (0, playlist_1.selectPlaylistLength)(state);
        var nextPlaylistItem = (0, playlist_1.selectCurrentPlaylistItemWithMediafile)(state);
        dispatch((0, player_1.updateNextTrackStartSchedule)(nextTrackStart));
        if (nextPlaylistItem) {
            dispatch((0, mediafiles_1.updateMediafileLastPlaytime)(nextPlaylistItem.mediafileId, filename));
            dispatch((0, playlist_2.updatePlaylistPlayStartTime)(Date.now()));
            dispatch((0, addRotationToHistory_1.default)());
            var historyItem = {
                onAir: onAir,
                rotationId: nextPlaylistItem.realRotationId
                    ? nextPlaylistItem.realRotationId
                    : nextPlaylistItem.rotationId,
                adcampaignId: nextPlaylistItem.adcampaignId,
                mediafileId: nextPlaylistItem.mediafileId,
                mediafilePerformerTitle: nextPlaylistItem.mediafile.performerTitle,
                playtime: nextPlaylistItem.playtime,
                mediafileRightholder: (_a = nextPlaylistItem.mediafile.rightholder) !== null && _a !== void 0 ? _a : 0,
                mediafileTitle: nextPlaylistItem.mediafile.title,
                mediafileType: nextPlaylistItem.type,
                pointId: (_b = state.point.id) !== null && _b !== void 0 ? _b : 0,
                streamId: (_c = state.point.streamId) !== null && _c !== void 0 ? _c : "0",
                mediafileFilename: filename,
                blocksPattern: nextPlaylistItem.blocksPattern,
                blockIndex: nextPlaylistItem.blockIndex,
            };
            dispatch((0, playbackHistory_1.addHistory)(historyItem, (_d = state.point.historyMaxItems) !== null && _d !== void 0 ? _d : historyDefaultMaxItems));
            var correction = Math.abs(historyItem.playtime - historyItem.onAir);
            logger.debug("Track playtime correction", { correction: correction });
            if (playlistLength < minPlaylistLength ||
                (regenerateOnCorrection && correction > maxCorrection)) {
                logger.warn("Triggering regeneration", {
                    correction: correction > maxCorrection,
                    correctionVal: correction,
                    playlistLength: playlistLength < minPlaylistLength,
                    playlistLengthVal: playlistLength,
                });
                dispatch((0, regeneratePlaylist_1.default)());
            }
        }
        dispatch((0, exportHistoryItems_1.default)());
    };
    action.type = addPlaybackHistoryItem.type;
    return action;
}
addPlaybackHistoryItem.type = "addPlaybackHistoryItem";
exports.default = addPlaybackHistoryItem;
//# sourceMappingURL=addPlaybackHistoryItem.js.map